import * as React from 'react'
import { Accordion, Button } from 'react-bootstrap'
import { Button as ButtonMui } from '@mui/material'
import { JobMode, workerHasPermission } from '../Job'
import Location from './Location'
import { copyObject } from '../../../../utils'
import * as _ from 'lodash'
import { currentUserIsClient, currentUserIsManager, currentUserIsWorker, getCurrentUserId } from '../../../../utils/currentUser'
import { JobT } from '../../../../types/Job'
import { LocationObj } from '../InitObjectJob'
import { useImmer } from 'use-immer'

interface LocationsProps {
    jobMode: JobMode
    job: JobT
    propagateDate?(activityDate: string): any
    updateJob(key: string, value: any): void
    required?: boolean
    showDetails?: boolean
    validated?: boolean
}

const Locations: React.FunctionComponent<LocationsProps> = (props): JSX.Element => {
    const [activeKey, setActiveKey] = React.useState(0)
    const [locations, setLocations] = useImmer([_.cloneDeep(LocationObj)])
    const isManager = currentUserIsManager()
    const isClient = currentUserIsClient()
    const isWorker = currentUserIsWorker()
    const currentUserId = getCurrentUserId()
    const editable = isManager
        || (isClient && (props?.jobMode == "new" || (props?.job.jobStatus == "inquiring")))
        || (isWorker && workerHasPermission('sales', props?.job, currentUserId))
        || !props.job?.id
    React.useEffect((): void => {
        if (!_.isEqual(locations, props?.job.locations)) {
            setLocations(props?.job.locations)
        }
    }, [props?.job.locations])


    /**
     *
     */
    const addLocation = (): void => {
        let locationsClone = copyObject(props.job.locations)
        let cloneLocation = copyObject(LocationObj)
        locationsClone.push(cloneLocation)
        setLocations(locationsClone)
        props.updateJob('locations', locationsClone)
        onChangeAccordion(locationsClone.length - 1)
    }
    /**
    *
    * @param index
    */
    const onChangeAccordion = (index: number): void => {
        if (index < 0) {
            index = 0
        }
        if (index != activeKey) setActiveKey(index)
        else setActiveKey(null)
    }

    const removeLocation = (index: number): void => {
        let locationsClone = copyObject(props.job.locations)
        const filteredItems = locationsClone.slice(0, index).concat(locationsClone.slice(index + 1, locationsClone.length))

        if (filteredItems.length <= 0) {
            let _item = copyObject(LocationObj)
            filteredItems.push(_item)
        }
        setLocations(filteredItems)
        props.updateJob('locations', filteredItems)
        onChangeAccordion(filteredItems.length - 1)
    }
    /**
      *
      * @param index
      * @param locationItem
      */
    const updateLocation = (index: number, locationItem: any): void => {   // TODO: Convert `any` to actual type
        let locationsClone = _.cloneDeep(locations)
        locationsClone[index] = locationItem
        setLocations(locationsClone)
        props.updateJob('locations', locationsClone)
    }

    const updateLocationCallback = React.useCallback((index: number, locationItem: any) => {
        return updateLocation(index, locationItem)
    }, [locations, activeKey]);



    const renderLocationCallback =(location, index) => {

        return (
            <Location
                disabled={!editable}
                job={props.job}
                jobMode={props.jobMode}
                key={index}
                index={index}
                location={location}
                onChangeAccordion={onChangeAccordion}
                propagateDate={props.propagateDate}
                updateLocation={updateLocation}
                removeLocation={removeLocation}
                showDetails={props.showDetails}
                required={props.required}
                validated={props.validated} />
        )
    };

    const renderLocations = (): Array<any> => {  // TODO: Convert `any`
        return locations.map((location, index) => {
            return renderLocationCallback(location, index)
        })

    }


    return (
        <div className="w-100  ">
            <Accordion defaultActiveKey={'0'} activeKey={`${activeKey}`}>
                {renderLocations()}
            </Accordion>
            {editable && <div className='p-2'> <ButtonMui

                style={{
                    // margin: 5,
                    marginTop: 10,
                    marginBottom: 10,
                    // width:"99%"
                }}
                fullWidth
                color='info'
                onClick={addLocation}
                type="button"
                variant="contained">
                Add Location
            </ButtonMui>
            </div>
            }

        </div>
    )
}

export default Locations
